<template>
  <div>
    <v-img src="@/assets/logo.png" height="200" contain></v-img>
    <v-card class="mx-auto mt-6" max-width="600">
      <v-card-title>Reset Password</v-card-title>
      <v-card-text>
        <!-- <p>
          Password must be at least 8 characters and contain at least one
          uppercase letter, one lowercase letter, one number and one special
          character
        </p>-->
        <v-form ref="form" v-model="valid" @submit.prevent="updatePassword">
          <v-text-field
            v-model="newPassword"
            :rules="[
              v => !!v || 'New password is required',
              v => v === this.confirmNewPassword || 'New passwords must match'
            ]"
            label="New Password"
            type="password"
            required
          ></v-text-field>
          <v-text-field
            v-model="confirmNewPassword"
            :rules="[
              v => !!v || 'New password confirmation is required',
              v => v === this.newPassword || 'New passwords must match'
            ]"
            label="Confirm New Password"
            type="password"
            required
          ></v-text-field>
          <v-btn class="mt-4" type="submit" color="primary darken-2">Submit</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>Password Reset Successfully!</v-card-title>
        <v-card-text>
          Your password has been successfuly reset. You may now return to the
          login screen and sign in.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text to="/login">Log In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  name: "PasswordReset",
  props: ["id"],
  data() {
    return {
      dialog: false,
      valid: true,
      newPassword: "",
      confirmNewPassword: ""
    };
  },
  methods: {
    async updatePassword() {
      if (this.$refs.form.validate()) {
        try {
          await UserService.resetPassword(this.id, {
            Password: this.newPassword
          });
          this.dialog = true;
        } catch {
          alert("Password must be a length of 6 or more.");
        }
      }
    }
  }
};
</script>

<style scoped></style>
